import { inject } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, Observable } from 'rxjs';

import { DuplicateViewContext, RequisitionsActions } from '@recruitee/requisitions-data';
import { generateUuid } from '@recruitee/utils';

export class DuplicateDispatcher {
  private store = inject(Store);
  private actions$ = inject(Actions);

  public execute$(id: number, viewContext: DuplicateViewContext): Observable<{ id: number }> {
    const uuid = generateUuid();
    this.store.dispatch(
      RequisitionsActions.duplicate({
        payload: {
          data: {
            id,
            correlationId: uuid,
          },
          viewContext,
        },
      }),
    );
    return this.actions$.pipe(
      ofType(RequisitionsActions.duplicateSuccess),
      filter(action => action.payload.correlationId === uuid),
      map(action => ({ id: action.payload.data.id })),
    );
  }
}
